module.exports = __webpack_public_path__ + "img/ic-filter-delete.bb1a0f5a.svg";